import { render, staticRenderFns } from "./IndividualLoyaltyCard.vue?vue&type=template&id=ef1d9134"
import script from "./IndividualLoyaltyCard.vue?vue&type=script&lang=js"
export * from "./IndividualLoyaltyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports